import { removeMultipleDots } from 'utils/removeMultipleDots';

const MAX_VALUE = 10;
const MAX_DECIMALS_LENGTH = 2;

type maskOptionsType = { isFocused?: boolean };

export const custodyFeePercentageTransform = {
  mask(value: string | number | undefined, options?: maskOptionsType) {
    const isFocused = options?.isFocused ?? false;

    if (value === undefined || value === '') {
      return '';
    }

    return `${value}${isFocused ? '' : '%'}`;
  },

  mapper(event: React.ChangeEvent<HTMLInputElement>) {
    let value = event.target.value;

    value = value.replace(',', '.');
    value = value === '.' ? '0.' : value;
    value = value.replace(/^00+/g, '0');

    const cleanValue = removeMultipleDots(value.replace(/[^0-9.]/g, ''));

    const [intPart, decimalNumber] = cleanValue.split('.');

    if (decimalNumber && decimalNumber.length > MAX_DECIMALS_LENGTH) {
      return [intPart, decimalNumber.slice(0, MAX_DECIMALS_LENGTH)].join('.');
    }

    if (Number(cleanValue) > MAX_VALUE) {
      return String(MAX_VALUE);
    }

    return cleanValue;
  },
};
